<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}"
            *ngIf="showBarComponent"></app-plugin-breadcrumb>
    </div>
    <!-- BREADCRUMB AREA - ENDS -->



 

    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">
                <div [ngClass]="navMenu ? 'col-xl-3 col-xxl-2' : ''" *ngIf="navMenu">
                    <div [style]="navmenuloadCss">
                        <app-plugin-navbar [datacollection]="{data:P_data}"
                            *ngIf="showNavComponent"></app-plugin-navbar>
                    </div>
                </div>
                <div [ngClass]="navMenu ? 'col-xl-9 col-xxl-10' : 'col-lg-12'">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details">
                                    <div class="title d-flex justify-content-between">
                                        <h2 class="screen-reader">{{ 'Seeyourdepot'|translate}}</h2>


                                        <!-- <a routerLink="/archivtender"
                                            class="btn btn-sm btn-outline-success screen-reader"><i
                                                class="bi bi-archive me-2"></i>{{ 'ArchiveTenders' | translate}}</a> -->
                                    </div>
                                    <div class="description">
                                        <div class="tenders">
                                            <div class="row">
                                                <div class="col-lg-12" >
                                                    <!-- search section -->
                                                    <div class="searchpanel notific-frm" >
                                                        <form [formGroup]="searchForm" (ngSubmit)="searchTender()">
                                                            <div class="row">



                                                                <div class="col-xxl-3 col-xl-3 col-md-6 col-sm-6 col-xs-12">
                                                                    <div class="form-group font-adjust">
                                                                        <label class="mb-2 mt-2 screen-reader"> <b>{{ 'Zone' |
                                                                                translate }} </b> </label>
                                <select class="form-select screen-reader" name="zone"
                                    id="zone" #zone formControlName="zone"
                                    (change)="GetRegion(zone.value)">
                                    <option value="" selected>{{ 'Zone' |
                                        translate }}</option>
                                 <ng-container *ngFor="let item of zoneList">
                                    <option value="{{ item.int_Demographic_Id }}" *ngIf="item.int_Demographic_Id!==32" >
                                        {{language=='English'?item.vch_Demographic_Name:item.vch_Demographic_Name_Hindi }}
                                    </option>
                                </ng-container>
                                </select>
                                                                    </div>
                                                                </div>
                                                                <div class="col-xxl-2 col-xl-2 col-md-6 col-sm-6 col-xs-12">
                                                                    <div class="form-group font-adjust">
                                                                        <label class="mb-2 mt-2 screen-reader"> <b> {{ 'Region' |
                                                                                translate }} </b> </label>
                                                                        <select class="form-select screen-reader" name="region"
                                                                            id="region" formControlName="region" #region_ (change)="GetDepotList(region_.value)">
                                                                            <option value="" selected>{{ 'Region' |
                                                                                translate }}
                                                                            </option>
                                                                            <option value="{{ item.vch_Code }}"
                                                                                *ngFor="let item of regionList">{{
                                                                                    language=='English'?item.vch_Demographic_Name:item.vch_Demographic_Name_Hindi }}</option>
                                                                        </select>
                                                                    </div> 
                                                                </div>
                                                                <div class="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-xs-12">
                                                                    <div class="form-group font-adjust">
                                                                        <label class="mb-2 mt-2 screen-reader"> <b>{{ 'Depot' |
                                                                            translate }}</b> </label>
                                                                        <!-- <select class="form-select screen-reader" name="depot"
                                                                            id="depot" formControlName="depot">
                                                                            <option value="" selected>{{ 'Depot' |
                                                                                translate }}
                                                                            </option>
                                                                            <option value="{{ item.DEPOT_CODE }}"
                                                                                *ngFor="let item of depotListIs">{{getDepotName(item.DEPOT_NAME)}}</option>
                                                                        </select> -->
                                                                        <ngx-select [items]="depotListIsForSelect" [allowClear]="true" (select)="depotModel($event)" [(ngModel)]="depotModel_" [multiple]="false" [placeholder]="'Depot' | translate"></ngx-select>
                                                                    </div>
                                                                </div>
                                                                <div class="col-xxl-2 col-xl-2 col-md-6 col-sm-6 col-xs-12 d-flex align-items-end">
                                                                        <div class="d-flex align-items-center gap-3 mt-3">
                                                                            <button type="submit" [attr.title]="language=='English'?'Search':'खोजें'"
                                                                                class="btn btn-outline-success screen-reader"
                                                                                [disabled]="ifdisabled"
                                                                                [innerHTML]="btncontent">
                                                                            </button>
                                                                            <div *ngIf="RefreshBtn">
                                                                                <button type="button" [attr.title]="language=='English'?'Refresh':'रीफ़्रेश करें'"
                                                                                    class="btn btn-outline-secondary py-0-2 screen-reader"
                                                                                    (click)="RefreshPage()">
                                                                                    <i class="bi bi-arrow-repeat fs-5"
                                                                                        aria-hidden="true"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                </div>

                                                            </div>
                                                        </form>
                                                    </div>
                                                    <!-- search section -->

                                                    <!-- tender section area -->
                                                    <div class="table-responsive  font-adjust">
                                                        <table class="table" aria-describedby="contactTable"> <!-- Contact Directory Table -->
                                                            <thead class="thead-light">
                                                                <tr>
                                                                    <th class="screen-reader" scope="col">#{{ 'Slno' |  translate }}</th>
                                                                    <th class="screen-reader" scope="col">{{ 'Zone' |  translate }}</th>
                                                                    <th class="screen-reader" scope="col">{{ 'Region' | translate }}</th>
                                                                    <th class="screen-reader" scope="col">{{ 'Depot' | translate }}</th>
                                                                    <th class="screen-reader" scope="col">{{ 'Links' | translate }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody *ngIf="depotListData.length > 0"> 
                                                                  
                                                                <tr *ngFor="let i= index;let item of depotListData | paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords};">
                                                                    <td class="screen-reader" *ngIf="currentPage==1">{{i+1}}</td>
                                                                    <td class="screen-reader" *ngIf="currentPage>1">{{(limit*(currentPage-1)) + (i+1)}}</td>                               
                                                                    <td class="screen-reader">{{ htmlTag(jsonConvert(item,'INT_ZONE_ID')) }}</td>
                                                                    <td class="screen-reader">{{ htmlTag(jsonConvert(item,'VCH_REGION_CODE')) }}</td>
                                                                    <td class="screen-reader">{{ htmlTag(jsonConvert(item,'VCH_DEPOT_CODE')) }}</td>
                                                                    <td class="screen-reader">
                                                                        <ng-container *ngFor="let link of item.depotLink">
                                                                            <span class="d-flex flex-column" *ngIf="link.linkName!==''">
                                                                                <a target="_blank" href="{{ link.linkName }}" [attr.title]="language=='English'?'Click Here':'यहाँ क्लिक करें'">{{"ClickHere"|translate}}</a>
                                                                            </span>
                                                                        </ng-container>
                                                                    </td>
                                                                   
                                                                </tr>
                                                            </tbody>
                                                            <tbody *ngIf="depotListData.length <= 0">
                                                            <tr>
                                                                <td class="screen-reader" colspan="5">
                                                                    <p class="text-center"> {{ "Nodataavailable" | translate }}</p>
                                                                </td>
                                                            </tr>
                                                            </tbody>

                                                        </table> 
                                                        <pagination-controls id="pg1" class="text-center screen-reader" (pageChange)="pageChanged($event)" *ngIf="totalRecords > limit"></pagination-controls>
                                                    </div>                                     
                                                </div>
 

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>